// extracted by mini-css-extract-plugin
export var productCardStyle = "product-card-module--productCardStyle--23lnc";
export var productDetailsStyle = "product-card-module--productDetailsStyle--2N58r";
export var productHeadingStyle = "product-card-module--productHeadingStyle--ZH28N";
export var productImageStyle = "product-card-module--productImageStyle--E6wVT";
export var productPrice = "product-card-module--productPrice--HRUSo";
export var productVendorStyle = "product-card-module--productVendorStyle--dbtlX";